import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 107.12 122.88"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#01a601;}.cls-1,.cls-2{fill-rule:evenodd;}"}</style>
    </defs>
    <title>{"secure-documents"}</title>
    <path
      className="cls-1"
      d="M107,65.8c1.54,31.07-9.94,49.42-30.28,57.08-19.64-7.17-31.25-24.73-30.39-57.56,10.33.54,20.46-1.68,30.28-9.31C85.3,61.53,96.41,66.76,107,65.8ZM60.18,86.39,66,86.31h.1l.44.12.11,0a19.71,19.71,0,0,1,1.74,1.11c.56.39,1.1.81,1.62,1.24s.75.66,1.11,1l.73.73q1.43-2.27,3-4.4c1.13-1.58,2.3-3.09,3.48-4.52s2.63-3,4-4.49,2.78-2.77,4.22-4.07a.41.41,0,0,1,.11-.07l.57-.22.14,0h6.36a.38.38,0,0,1,.38.37.41.41,0,0,1-.11.27l-1.28,1.41q-2.94,3.27-5.6,6.64c-1.8,2.26-3.5,4.57-5.12,6.9s-3.12,4.68-4.56,7.08-2.82,4.86-4.1,7.34l-.81,1.55a.38.38,0,0,1-.5.16.33.33,0,0,1-.17-.18l-.73-1.57a41,41,0,0,0-2.22-4.15,34.48,34.48,0,0,0-2.65-3.74,31.36,31.36,0,0,0-6.74-6.24.38.38,0,0,1-.14-.43l.46-1.54a.38.38,0,0,1,.38-.27Z"
    />
    <path
      className="cls-2"
      d="M81.58,17.5H90.7A6.52,6.52,0,0,1,97.22,24l-.33,25.52-5.25-.9V24a.84.84,0,0,0-.29-.65.92.92,0,0,0-.65-.28H81.58V45.26c-1.83-1-3.68-2.16-5.55-3.34h0l0,0V6.52a.87.87,0,0,0-.28-.65,1,1,0,0,0-.66-.29H6.52a.88.88,0,0,0-.65.29.89.89,0,0,0-.29.65v78a.88.88,0,0,0,.29.66.92.92,0,0,0,.65.28H36q.57,2.87,1.28,5.58H21.21v10.37a.84.84,0,0,0,.29.65.89.89,0,0,0,.65.29H41.2c.83,1.94,1.75,3.8,2.72,5.58H22.15a6.52,6.52,0,0,1-6.52-6.52V91.08H6.52A6.54,6.54,0,0,1,0,84.55v-78A6.52,6.52,0,0,1,6.52,0H75.06a6.52,6.52,0,0,1,6.52,6.52v11ZM19.35,58.59a2.87,2.87,0,0,1,0-5.74H40.5a2.87,2.87,0,1,1,0,5.74Zm0-16.75a2.87,2.87,0,0,1,0-5.74h43.3a2.87,2.87,0,1,1,0,5.74Zm0-16.75a2.87,2.87,0,0,1,0-5.73H62.66a2.87,2.87,0,0,1,0,5.73Z"
    />
  </svg>
);
export default SVGComponent;
